module.exports = __webpack_public_path__ + "static/media/image.5361d4c5.png";